<script lang="ts">
	import { run } from "svelte/legacy"

	import { ColorPickerStore, closeDeviceColorPicker } from "./DeviceColorPickerContext"
	import TrackColorPickerPointer from "./DeviceColorPickerPointer.svelte"
	import { PROJECTOR_COLOR_OPTIONS, Device, DataHandlerDevice } from "luxedo-data"
	import { Responsive } from "responsive"

	let isOpen = $state(false)
	let device: Device
	let onColorChange: Function

	let initialLeft: number = $state()
	let initialTop: number = $state()
	let initialClickTop: number = $state()

	ColorPickerStore.subscribe((ctx) => {
		isOpen = ctx.isOpen
		if (ctx.isOpen) {
			device = ctx.device
			onColorChange = ctx.onColorChange
			initialTop = ctx.top
			initialClickTop = ctx.top
			initialLeft = ctx.left
		} else {
			device = undefined
			initialTop = undefined
			initialLeft = undefined
			onColorChange = undefined
		}
	})

	let isMobile = $derived(Responsive.isMobile)

	let actualLeft: number = $derived.by(() => {
		if (isMobile) {
			return 0
		}

		return initialLeft + 96
	})

	let actualTop: number = $derived.by(() => {
		if (isMobile) {
			return initialTop + 36
		}

		return initialTop - 8
	})

	let pointerTop: number = $derived.by(() => {
		if (isMobile) {
			return -32
		}

		return initialClickTop - initialTop + 20
	})

	let colorPickerElem: HTMLDivElement = $state()

	async function updateTrackColor(index: number) {
		if (device instanceof Device) device._color = index
		else onColorChange(index)

		await DataHandlerDevice.push([device])
		closeDeviceColorPicker()
	}

	function ensureBoundsWithinWindow() {
		const { bottom } = colorPickerElem.getBoundingClientRect()
		if (bottom > window.innerHeight) initialTop -= bottom - window.innerHeight + 32
	}

	run(() => {
		isOpen && colorPickerElem && ensureBoundsWithinWindow()
	})
</script>

{#if isOpen}
	<div
		class="bg-clear"
		onclick={(e) => {
			e.stopPropagation()
			closeDeviceColorPicker()
		}}
		onkeydown={undefined}
	></div>
	<div
		id="track-color-picker"
		class:isMobile
		bind:this={colorPickerElem}
		style="left: {actualLeft}px; top: {actualTop}px;"
	>
		{#each PROJECTOR_COLOR_OPTIONS as color, i}
			<div
				onclick={(e) => {
					e.stopPropagation()
					updateTrackColor(i)
				}}
				class="color-option"
				style="background-color: #{color};"
				onkeydown={undefined}
			></div>
		{/each}
		<div id="track-color-point" style="top: {pointerTop}px;">
			<TrackColorPickerPointer />
		</div>
	</div>
{/if}

<style>
	#track-color-picker {
		border: 1px solid var(--color-border);
		position: absolute;
		z-index: 102;
		backdrop-filter: blur(3rem);
		border-radius: var(--br);
		background-color: var(--color-bg);
		padding: 1rem;
		display: grid;
		grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
		grid-template-rows: 1fr 1fr 1fr 1fr;
		gap: 1rem;
	}

	#track-color-point {
		z-index: 101;
		position: absolute;
		width: 2rem;
		height: 2rem;
		border-radius: 1rem;
		backdrop-filter: blur(3rem);
		left: -1.75rem;
		/* top: 1rem; */
	}

	#track-color-point :global(svg) {
		width: 2rem;
		height: 2rem;
	}

	.color-option {
		cursor: pointer;
		width: 1.5rem;
		height: 1.5rem;
		border-radius: 0.25rem;

		transition: transform 250ms;
	}

	.color-option:hover,
	.color-option:focus-visible {
		transform: scale(1.2);
	}

	.bg-clear {
		background-color: var(--color-bg);
		position: fixed;
		top: 0;
		left: 0;
		width: 100vw;
		height: 100vh;
		z-index: 100;
	}

	.isMobile #track-color-point {
		transform: rotate(90deg) translateX(4px) translateY(-50px);
	}
</style>
